import names from '@/modules/recording/routers/names'
import {ACCOUNTS_INSTANCE, ORGANIZATION_INSTANCE, RECORDING_INSTANCE} from "@/helper/consts";
import AdminMenu from "@/modules/recording/page/admin/AdminMenu"
import EventsList from "@/modules/recording/page/admin/events/EventsList"
import IntervalsList from "@/modules/recording/page/admin/events/intervals/IntervalsList"
import Permission from "@/modules/recording/page/admin/permission/List.vue"
import Emails from "@/modules/recording/page/admin/emails/MailsList.vue"
export default ([
    {
        path: '/admin',
        name: names.ADMIN._BASE,
        component: AdminMenu,
        meta: {
            breadcrumb: 'Администрирование',
            requiredAuth: true,
            instances: [
                RECORDING_INSTANCE,
                ACCOUNTS_INSTANCE
            ],
        },
        children: [
            {
                path: 'events',
                name: names.ADMIN.EVENTS,
                component: EventsList,
                meta: {
                    breadcrumb: 'Список',
                    requiredAuth: true,
                    instances: [
                        RECORDING_INSTANCE,
                    ],
                },
                children:[
                    {
                        path: ':event/:date/interval',
                        name: names.ADMIN.INTERVAL,
                        component: IntervalsList,
                        meta: {
                            breadcrumb: 'Интервалы',
                            requiredAuth: true,
                            instances: [
                                RECORDING_INSTANCE,
                            ],
                        },
                    }
                ]
            },

            {
                path: 'permission',
                name: names.ADMIN.PERMISSION,
                component: Permission,
                meta: {
                    breadcrumb: 'Права',
                    requiredAuth: true,
                    instances: [
                        RECORDING_INSTANCE,
                        ACCOUNTS_INSTANCE,
                        ORGANIZATION_INSTANCE
                    ],
                },
            },
            {
                path: 'mails',
                name: names.ADMIN.EMAILS,
                component: Emails,
                meta: {
                    breadcrumb: 'Рассылки',
                    requiredAuth: true,
                    instances: [
                        RECORDING_INSTANCE,
                        ACCOUNTS_INSTANCE,
                        ORGANIZATION_INSTANCE
                    ],
                },
            },
        ]

    }
])
